export const ROLES_TAB_TYPE_USERS = 'USERS';
export const ROLES_TAB_TYPE_TEAMS = 'TEAMS';

export const USER_INVITE = 'USER_INVITE';
export const USER_VIEW = 'USER_VIEW';
export const USER_EDIT = 'USER_EDIT';

export const USER_INACTIVE = 'inactive';

export const USER_STATUS = ['deactivate', 'active'];

export const RBAC_TYPE_HOME = 'home';

export const RBAC_TYPE_GROUPS = 'groups';
export const RBAC_TYPE_BRANDS = 'brands';
export const RBAC_TYPE_HOTELS = 'hotels';

export const RBAC_TYPE_HOTEL_RESTAURANT = 'restaurant';
export const RBAC_TYPE_HOTEL_SPA = 'spa';
export const RBAC_TYPE_HOTEL_ROOMS = 'rooms';
export const RBAC_TYPE_HOTEL_LOCATION = 'location';
export const RBAC_TYPE_HOTEL_AMENITIES = 'amenities';
export const RBAC_TYPE_HOTEL_ACCOMMODATIONS = 'accommodations';

export const RBAC_TYPE_USERS = 'users';
export const RBAC_TYPE_TEAMS = 'teams';
export const RBAC_TYPE_ANALYTICS = 'analytics';
export const RBAC_TYPE_STATISTICS = 'statistics';
export const RBAC_TYPE_CHAT = 'chat';

export const RBAC_TYPE_HOTEL_SYSTEMS = 'hotelSystems';
export const RBAC_TYPE_GRMS = 'grms';
export const RBAC_TYPE_ENTERTAINMENT = 'entertainment';
export const RBAC_TYPE_VENDOR_CONFIGS = 'vendorConfig';
export const RBAC_TYPE_DESIGN_CONFIGS = 'designConfigs';
export const RBAC_TYPE_DEVICE_MONITORING = 'deviceMonitoring';
export const RBAC_TYPE_APP_CONFIGURATIONS = 'appConfigurations';

export const RBAC_TYPE_SERVICES_IN_ROOM_DINING = 'inRoomDining';
export const RBAC_TYPE_SERVICES_SERVICE_REQUEST = 'serviceRequest';
export const RBAC_TYPE_SERVICES_TELEPHONY = 'telephony';

export const RBAC_TYPE_CMS_OFFERS = 'offers';
export const RBAC_TYPE_CMS_CITY_GUIDE = 'cityGuide';
export const RBAC_TYPE_CMS_TVCHANNELS = 'tvChannels';
export const RBAC_TYPE_CMS_FEEDBACK = 'feedback';
export const RBAC_TYPE_CMS_ACTIVITYCALENDAR = 'activity';

export const RBAC_TYPE_NOTIFICATIONS = 'notifications';
export const RBAC_TYPE_EMAIL_SERVICES = 'emailConfiguration';
export const RBAC_TYPE_MESSAGES = 'welcomeMessage';

export const RBAC_TYPE_DASHBOARD_ACCOMODATION = 'accommodationDashboard';
export const RBAC_TYPE_DASHBOARD_IRD = 'inRoomDiningDashboard';
export const RBAC_TYPE_DASHBOARD_RESTAURANT = 'restaurantDashboard';
export const RBAC_TYPE_DASHBOARD_SERVICE_REQUEST = 'serviceRequestDashboard';
export const RBAC_TYPE_DASHBOARD_SPA = 'spaDashboard';
export const RBAC_FNB_DASHBOARD_SPA = 'fAndBDashboard';

export const RBAC_PERMISSION_LEVEL_NO_ACCESS = 0;
export const RBAC_PERMISSION_LEVEL_VIEW_ONLY = 1;
export const RBAC_PERMISSION_LEVEL_FULL_ACCESS = 2;
export const RBAC_PERMISSION_LEVEL_API_READ_ONLY = 3;
